import script from "./reviewCore.vue?vue&type=script&setup=true&lang=js"
export * from "./reviewCore.vue?vue&type=script&setup=true&lang=js"

import "./reviewCore.vue?vue&type=style&index=0&id=5d070a62&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src2302593107/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d070a62"]])

export default __exports__